'use es6';

import * as ReviewTypes from 'marketplace-ui-reviews/constants/ReviewType';
import { getApiClient } from '../utils/apiClient';
let apiBase = 'ecosystem/v1';
export const setApiBase = base => {
  apiBase = base;
};
export const getAppIntegrations = () => {
  return getApiClient().get(`${apiBase}/apps/tags/app-integrations`);
};
export const emailAdmin = (adminUserId, listingId, permissions) => {
  return getApiClient().post(`${apiBase}/permissions/request-from-admin`, {
    data: {
      adminUserId,
      listingId,
      permissions
    }
  });
};
export const fetchReviews = queries => {
  return getApiClient().post(`${apiBase}/reviews/search`, {
    data: Object.assign({
      reviewTypes: [ReviewTypes.APP]
    }, queries)
  });
};
export const fetchReviewsStats = offeringId => getApiClient().post(`${apiBase}/reviews/stats`, {
  data: {
    entityId: offeringId,
    reviewType: ReviewTypes.APP
  }
});
export const writeReview = review => {
  return getApiClient().post(`${apiBase}/reviews`, {
    data: review
  });
};
export const toggleReviewHelpful = (reviewId, isHelpful) => getApiClient().put(`${apiBase}/reviews/${reviewId}/helpful`, {
  data: isHelpful
});